import { clearAllBodyScrollLocks, enableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef } from 'react';

import useClickOutside from '~/hooks/useClickOutside';
import type { ModalFrameProps } from '~/legacy/types';
import {
  bem,
  getAppRoot,
  modalFramePosition,
  modalFrameSemantic
} from '~/legacy/utils';

import Icon from './Icon';

const ModalFrame = ({
  onCloseClick,
  children,
  centered,
  setBorderRadius,
  disableClickOutside,
  hideClose,
  isFullBody,
  background = modalFrameSemantic.WHITE,
  isFullWidth,
  positionSemantic = modalFramePosition.DEFAULT,
  showBorder
}: ModalFrameProps) => {
  const ref = useRef(null);
  const scrollTargetElement = getAppRoot();
  useClickOutside(ref, onCloseClick, disableClickOutside);

  useEffect(() => {
    const handler = ({ keyCode }: { keyCode: number }) => {
      if (keyCode === 27) {
        onCloseClick();
      }
    };
    document.addEventListener('keyup', handler);

    return () => document.removeEventListener('keyup', handler);
  });

  const onCloseOverlay = () => {
    onCloseClick();
    clearAllBodyScrollLocks();
    scrollTargetElement && enableBodyScroll(scrollTargetElement);
  };

  const frameSemantic = [
    centered ? 'centered' : '',
    setBorderRadius ? 'set-border-radius' : '',
    isFullBody ? 'is-full-body' : '',
    isFullWidth ? 'is-full-width' : '',
    background,
    `position-${positionSemantic}`,
    showBorder ? 'show-border' : '',
    'tss-domain'
  ];

  return (
    <div className={bem('modal-frame', frameSemantic)} ref={ref}>
      <div
        className={bem('modal-frame__body', [
          background,
          isFullBody ? 'is-full-body' : ''
        ])}
      >
        <div className={bem('modal-frame__content', { isFullBody })}>
          {!hideClose && (
            <div className="modal-frame__close">
              <Icon
                onClick={onCloseOverlay}
                name="close"
                width="18"
                height="18"
                viewBox="0 0 1792 1792"
                fill="#949495"
                className="modal-frame__close__icon"
              />
            </div>
          )}
          <div className="modal-frame__inner">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ModalFrame;
